export default __webpack_public_path__ + "static/media/arrow.f214ad63c8d4dbbc6655a5b43917e64b.svg";